import React from 'react'
import { Link } from "react-router-dom";

import '../../styles/banner.css'
const Banners = () => {
	return (
		<div className="banned">
			<div className="banned-container">
				<ul>
					<li className='beforeWas'>
						<div className="bnnr1">
							<h2 >Your account <br /> <span>E-Solutions </span> it's free</h2>
							<h4 >Open your account with ease and select your card according to your needs! it's easy fast and secure.</h4>
							<div className="banned-links">
								<Link to={`/sign-in`}>...</Link>
								<Link to={`/sign-in`}>...</Link>
							</div>
						</div>
						<div className="bnnr2">
							<h2>Do you need  <br /> <span>Financing </span> ?</h2>
							<h4>With First Franklin Financial Corporation, you have the freedom to borrow and repay flexibly.</h4>
							<div className="banned-links">
								<Link to={`/sign-in`}>...</Link>
								<Link to={`/sign-in`}>...</Link>
							</div>
						</div>
						<div className="bnnr3">
							<h2>you don't  <br /> <span>need to  </span>  move</h2>
							<h4>Our online banking services are even easier to use. Register Now - It's easy and fast!</h4>
							<div className="banned-links">
								<Link to={`/sign-in`}>...</Link>
								<Link to={`/sign-in`}>...</Link>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default Banners